import { useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Global state
let currentState = navigator.onLine ? "online" : "offline";
let lastShownState = null;
let toastTimer = null;
const TOAST_ID = "network-status";

const showToast = (state) => {
  if (toastTimer) {
    clearTimeout(toastTimer);
  }

  toastTimer = setTimeout(() => {
    // ✅ Only show if state actually changed
    if (state === lastShownState) return;

    lastShownState = state;

    toast.dismiss(TOAST_ID);

    if (state === "offline") {
      toast.warn("You are offline. Please check your internet connection!", {
        toastId: TOAST_ID,
        position: "top-center",
        autoClose: 5000,
      });
    } else {
      toast.success("You are back online!", {
        toastId: TOAST_ID,
        position: "top-center",
        autoClose: 5000,
      });
    }

    toastTimer = null;
  }, 200);
};

// ✅ Trigger ONLY on actual change
const handleOffline = () => {
  if (currentState !== "offline") {
    currentState = "offline";
    showToast("offline");
  }
};

const handleOnline = () => {
  if (currentState !== "online") {
    currentState = "online";
    showToast("online");
  }
};

const NetworkStatusHandler = () => {
  useEffect(() => {
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);

      if (toastTimer) {
        clearTimeout(toastTimer);
      }
    };
  }, []);

  return null;
};

export default NetworkStatusHandler;
